import { createAsyncThunk } from "@reduxjs/toolkit";
import { API } from "../authSlice";

export const changePassword = createAsyncThunk<any, any, { rejectValue: { message: string } }>(
    "auth/changePassword",
    async (payload: any, thunkAPI) => {
        try {
            const response = await fetch(`${API}/v1/users/me/password`, {
                method: "PUT",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({
                    code: payload.code,
                    newPassword: payload.newPassword,
                    repeatedPassword: payload.repeatedPassword
                })
            });

            const data = await response.json();

            if (!response.ok) {
                return thunkAPI.rejectWithValue({
                    message: data?.data?.errors || "Неизвестная ошибка"
                });
            }

            return data;
        } catch (error: any) {
            return thunkAPI.rejectWithValue({ message: error.message });
        }
    }
);